import type {PostContentParams} from 'domain/usecases/private/content/post-content';
import {makePostContent} from 'main/factories/usecases/private/content/post-content-factory';

export const postContent = async (params: PostContentParams) => {
	const response = await makePostContent().post(params);
	return response;
};
